import {Wifi} from './Wifi';

export class Configuration {
    public enableForceChecks: boolean;
    public enableToleranceTime: boolean;
    public toleranceTime: number;
    public maxForceChecks: number;
    public maxForceChecksOut: number;
    public enableMaxForceChecks: boolean;
    public enableMaxForceChecksOut: boolean;
    public wifiList: Array<Wifi>;

    constructor() {
        this.enableForceChecks = true;
        this.enableToleranceTime = true;
        this.toleranceTime = 4;
        this.maxForceChecks = 5;
        this.maxForceChecksOut = 5;
        this.enableMaxForceChecks = true;
        this.enableMaxForceChecksOut = true;
        this.wifiList = [];
    }
}



// WEBPACK FOOTER //
// ./src/models/Configuration.ts